/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__Question_3Inputs */

const en_help_center__payments_n_refunds__question_3 = /** @type {(inputs: Help_Center__Payments_N_Refunds__Question_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are bid packages refundable?`)
};

/**
* | output |
* | --- |
* | "Are bid packages refundable?" |
*
* @param {Help_Center__Payments_N_Refunds__Question_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__question_3 = /** @type {((inputs?: Help_Center__Payments_N_Refunds__Question_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__Question_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__question_3(inputs)
});